export default __webpack_public_path__ + "static/media/descricao1.3bf48708.png";